/* eslint-disable max-len */
import React from 'react';
import { Typography } from '@vtblife/uikit';
import { SliderMoneyInputField, Size, SliderNumberInputField } from '@vtblife/uikit/legacy';

import classname from '@search/classname/src';
import { declensionByNumber } from '@search/helpers/src/declensionByNumber';
import { MortgagePurpose, MortgagePropertyType, MortgageProgramCodeType } from '@search/graphql-typings';

import './style.css';

const cn = classname.bind(null, 'MortgageNumberFields');

const declensionYear = (year: number) => declensionByNumber(year, [ 'год', 'года', 'лет' ]);
const formatYear = (value: string) => {
    return `${value} ${declensionYear(Number(value.replace(',', '.')))}`;
};

export const MortgageNumberFields = ({
    isMobile,
    formattedPrice,
    term,
    formState,
    ownAmount,
    handleOwnAmountChange,
    handleTermChange
}: {
    isMobile?: boolean;
    formattedPrice: string;
    formState: {
        term: number;
        propertyCost: number;
        ownAmount: number;
        purpose: MortgagePurpose;
        regionId: number;
        propertyType: MortgagePropertyType;
        programCode: MortgageProgramCodeType;
    };
    ownAmount: {
        min: number;
        max: number;
        step: number;
        percent: string;
        labelFrom: string;
        labelTo: string;
    };
    term: {
        min: number;
        max: number;
    };
    handleOwnAmountChange: (value: number) => void;
    handleTermChange: (value: number) => void;
}) => {
    const afterContent = <Typography variant='h4' color={isMobile ? 'black-300-alpha' : 'black-400'}>{ownAmount.percent}</Typography>;

    const validatedOwnAmount = React.useMemo(() => {
        if (formState.ownAmount < ownAmount.min) return ownAmount.min;
        if (formState.ownAmount > ownAmount.max) return ownAmount.min;

        return formState.ownAmount;
    }, [ formState.ownAmount, ownAmount.max, ownAmount.min ]);

    return (
        <div className={cn()}>
            <div className={cn('price')}>
                <Typography variant='primary-alone' bold>{formattedPrice}</Typography>
                <Typography variant='secondary-alone' color='secondary'>
                    Стоимость недвижимости
                </Typography>
            </div>
            <div className={cn('fields', { isMobile })}>
                <div className={cn('field', { grid: 'ownAmount' })}>
                    <SliderMoneyInputField
                        contentAfter={afterContent}
                        inputMode='decimal'
                        label='Первоначальный взнос'
                        max={ownAmount.max}
                        min={ownAmount.min}
                        name='ownAmount'
                        // @ts-ignore
                        onChange={handleOwnAmountChange}
                        size={Size.Large}
                        step={ownAmount.step}
                        value={validatedOwnAmount}
                        hideNoteSpace
                        fullWidth={isMobile}
                    />
                </div>
                <div className={cn('field', { grid: 'term', isMobile })}>
                    <SliderNumberInputField
                        formatter={formatYear}
                        inputMode='numeric'
                        label='Срок кредита'
                        max={term.max}
                        min={term.min}
                        name='term'
                        // @ts-ignore
                        onChange={handleTermChange}
                        size={Size.Large}
                        value={formState.term ? formState.term : 1}
                        hideNoteSpace
                        fullWidth={isMobile}
                    />
                </div>
            </div>
        </div>
    );
};
